import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { withRouter } from 'react-router-dom'
import {
  ScheduleSvg,
  NeverExpiresSvg,
  AddPersonalMsgSvg,
} from '../shared/icons/svg-images'
import glamorousIcon from '../shared/icons'
import { Message } from '@paypalcorp/worldready-react'

const Div = glamorous.div({
  textAlign: 'center',
  margin: '12px 0',
})
const Label = glamorous.div('vx_text-1', {
  textAlign: 'center',
  fontSize: '30px',
  paddingBottom: '36px',
})

const Row = glamorous.div({
  color: '#4a4a4a',
  marginLeft: '80px',
  marginRight: '80px',
  textAlign: 'center',
  '@media only screen and (max-width: 768px)': {
    marginLeft: 0,
    marginRight: 0,
  },
})

const Button = glamorous.button('vx_btn', {
  width: '270px',
  height: '48px',
  borderRadius: '24px',
  padding: '0',
  '@media only screen and (max-width: 768px)': {
    width: '271px',
    height: '36px',
    maxWidth: '350px',
  },
})

const Option = glamorous.div({
  display: 'flex',
  flexFlow: 'column nowrap',
  '@media only screen and (max-width: 768px)': {
    flexDirection: 'column-reverse',
    marginBottom: 36,
  },
})

const Text = glamorous.div({})

const IconContainer = glamorous.div({
  display: 'flex',
  paddingTop: 24,
  paddingBottom: 60,
  marginTop: 'auto',
  '@media only screen and (max-width: 768px)': {
    paddingTop: 0,
    paddingBottom: 0,
  },
})

const ScheduleTheDeliveryICON = glamorousIcon({
  flex: '1 1 auto',
  '& svg': { height: '88.2', width: '79.1' },
})

ScheduleTheDeliveryICON.defaultProps = { svg: ScheduleSvg }

const NeverExpiresICON = glamorousIcon({
  flex: '1 1 auto',
  '& svg': { height: '88.2', width: '79.1' },
})

NeverExpiresICON.defaultProps = { svg: NeverExpiresSvg }

const PersonalMsgICON = glamorousIcon({
  flex: '1 1 auto',
  '& svg': { height: '88.2', width: '79.1' },
})

PersonalMsgICON.defaultProps = { svg: AddPersonalMsgSvg }

class GiftOfChoice extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    parentPage: PropTypes.string,
  }

  handleBrowseAll = () => {
    this.props.history.push('/all')
  }

  render() {
    return (
      <div className="container">
        <Div style={{ paddingTop: '12px' }}>
          <Button
            onClick={this.handleBrowseAll}
            name="SeeAllGiftCardsButton"
            data-pagename={`main:consumer:gifts:home:${
              this.props.parentPage || ''
            }`}
            data-pagename2={`main:consumer:gifts:home:${
              this.props.parentPage || ''
            }:::`}
          >
            <Message id="pages/landing.landing.btn.seeThemAll" />
          </Button>
        </Div>
        <Label>
          <Message id="pages/landing.landing.moreLoveLessHassle" />
        </Label>
        <div className="container">
          <Row className="row vx_text-4">
            <Option className="col-md-4 col-sm-12">
              <Text>
                <Message id="pages/landing.landing.sendAnyDay" />
              </Text>
              <IconContainer>
                <ScheduleTheDeliveryICON />
              </IconContainer>
            </Option>
            <Option className="col-md-4 col-sm-12">
              <Text>
                <Message id="pages/landing.landing.neverExpire" />
              </Text>
              <IconContainer>
                <NeverExpiresICON />
              </IconContainer>
            </Option>
            <Option className="col-md-4 col-sm-12">
              <Text>
                <Message id="pages/landing.landing.personalTouch" />
              </Text>
              <IconContainer>
                <PersonalMsgICON />
              </IconContainer>
            </Option>
          </Row>
        </div>
      </div>
    )
  }
}

export default withRouter(GiftOfChoice)
